import * as types from "../types/index";
import { core } from "./core";

export const getHolidays = (data) => {
  //let offset = data && data.offset ? data.offset : 0;
  if (data.year && data.country) {
    return core.API(
      "GET",
      `/holidays?country=${data.country}&year=${data.year}`,
      types.GET_HOLIDAYS,
      types.GET_HOLIDAYS_SUCCESS,
      types.GET_HOLIDAYS_FAILURE
    );
  }
};
export const getCompanyHolidays = (data) => {
  return core.API(
    "GET",
    `/company/holidays${data && data.year ? `?year=${data.year}` : ""}`,
    types.GET_COMPANY_HOLIDAYS,
    types.GET_COMPANY_HOLIDAYS_SUCCESS,
    types.GET_COMPANY_HOLIDAYS_FAILURE
  );
};
export const addCompanyHolidays = (data) => {
  return core.API(
    "POST",
    `/company/holiday`,
    types.ADD_COMPANY_HOLIDAYS,
    types.ADD_COMPANY_HOLIDAYS_SUCCESS,
    types.ADD_COMPANY_HOLIDAYS_FAILURE,
    data
  );
};
export const deleteCompanyHoliday = (id) => {
  return core.API(
    "DELETE",
    `/company/holiday/${id}`,
    types.DELETE_COMPANY_HOLIDAY,
    types.DELETE_COMPANY_HOLIDAY_SUCCESS,
    types.DELETE_COMPANY_HOLIDAY_FAILURE
  );
};
export const putCompanyHoliday = (id, data) => {
  return core.API(
    "PUT",
    `/company/holiday/${id}/`,
    types.PUT_COMPANY_HOLIDAY,
    types.PUT_COMPANY_HOLIDAY_SUCCESS,
    types.PUT_COMPANY_HOLIDAY_FAILURE,
    data
  );
};
export const copyCompanyHoliday = (id, data) => {
  return core.API(
    "POST",
    `/company/holiday/${id}/copy`,
    types.COPY_COMPANY_HOLIDAY,
    types.COPY_COMPANY_HOLIDAY_SUCCESS,
    types.COPY_COMPANY_HOLIDAY_FAILURE,
    data
  );
};
export const getHolidayAutofillData = (holidayId) => {
  return core.API(
    "GET",
    `/company/holiday/${holidayId}/group-holidays`,
    types.GET_HOLIDAY_AUTOFILL,
    types.GET_HOLIDAY_AUTOFILL_SUCCESS,
    types.GET_HOLIDAY_AUTOFILL_FAILURE
  );
};
export const addHolidayAutofill = (data, holidayId) => {
  return core.API(
    "POST",
    `/company/holiday/${holidayId}/group-holiday`,
    types.ADD_HOLIDAY_AUTOFILL,
    types.ADD_HOLIDAY_AUTOFILL_SUCCESS,
    types.ADD_HOLIDAY_AUTOFILL_FAILURE,
    data
  );
};
export const deleteHolidayAutofill = (holidayId, autofillId) => {
  return core.API(
    "DELETE",
    `/company/holiday/${holidayId}/group-holiday/${autofillId}`,
    types.DELETE_HOLIDAY_AUTOFILL,
    types.DELETE_HOLIDAY_AUTOFILL_SUCCESS,
    types.DELETE_HOLIDAY_AUTOFILL_FAILURE
  );
};
export const editHolidayAutofill = (data, holidayId, autofillId) => {
  return core.API(
    "PUT",
    `/company/holiday/${holidayId}/group-holiday/${autofillId}`,
    types.PUT_HOLIDAY_AUTOFILL,
    types.PUT_HOLIDAY_AUTOFILL_SUCCESS,
    types.PUT_HOLIDAY_AUTOFILL_FAILURE,
    data
  );
};
